import axios from "axios";
import { reactive, ref } from "vue";
import router from "../../router/shop";
import { useToast } from "vue-toastification";

class Auth {
  constructor() {
    this.errors = ref(null);
    this.loading = ref(false);
    this.submit = ref(false);
    this.message = ref(null);
    this.isNotification = ref(false);
    this.enterCode = ref(false);
    this.timeout = ref(null);
    this.cities = ref([]);
    this.ref = ref('');
    this.interval = null;
    this.isUpdated = false;
    this.award = reactive({});
    this.privacy = ref('');
    this.token = ref(localStorage.getItem("token"));
    let userData = localStorage.getItem("user");
    this.user = ref(userData ? JSON.parse(userData) : {});
    this.toast = useToast();
    this.isSidebar = ref(this.token.value && this.user.value?.access ? true: false);
    if (this.token.value)
      axios.defaults.headers.common["Authorization"] = "Bearer " + this.token.value;
  }

  async login(phone) {
    this.loading.value = true;
    await axios
      .post("login", { phone })
      .then((res) => {
        const data = res.data;
        this.loading.value = false;
        if(data.error)this.toast.error(data.message);
        else {
          this.enterCode.value = true;
          this.starTimer(data.timeout);
          this.toast.success(data.message);
        }
      })
      .catch((error) => {
        window.networkError(error);
        const response = error.response;
        this.loading.value = false;
      });
  }

  async verification(phone, token) {
    this.loading.value = true;
    await axios
      .post("verification", { phone: phone, verification_code: token })
      .then((res) => {
        this.loading.value = false;
        const data = res.data.data;
        this.toast.success(res.data.message);
        this.setUser(data);
        this.isSidebar.value = data.access && data.privacy_confirm;
        router.push({ name: data.access ? "product" : "profile" });
        this.resetForm();
      })
      .catch((error) => {
        window.networkError(error);
        const response = error.response;
        this.loading.value = false;
      });
  }

  async register(user) {
    this.loading.value = true;
    await axios
      .post("register", user)
      .then((res) => {
        this.loading.value = false;
        const data = res.data;
        if(data.error)this.toast.error(data.message);
        else {
          this.enterCode.value = true;
          this.starTimer(data.timeout);
          this.toast.success(data.message);
        }
      })
      .catch((error) => {
        window.networkError(error);
        const response = error.response;
        this.loading.value = false;
      });
  }

  async getUser(update = false) {
    this.errors.value = '';
    this.loading.value = !update;
    await axios
      .get("user" + (update ? '?update=1' : ''))
      .then((res) => {
        this.loading.value = false;
        const data = res.data.data;
        this.isSidebar.value = ['active','limited'].includes(data.status);
        this.user.value = data;
        this.isNotification.value = router.currentRoute.value.name == 'notification' ? false : this.user.value.notification && this.user.value.notification_count;
        if(update) this.isUpdated = true
        this.setUser(data);
        if(!data.privacy_confirm || !this.isSidebar.value) router.push({name: 'profile'});
      })
      .catch((error) => {
        if(!update)this.errors.value = error;
        this.loading.value = false;
      });
  }

  async editUser() {
    this.errors.value = '';
    this.loading.value = true;
    await axios
      .get("user/edit" )
      .then((res) => {
        this.loading.value = false;
        const data = res.data.data;
        this.isSidebar.value = ['active','limited'].includes(data.status);
        this.user.value = data;
        this.privacy.value = res.data.privacy;
        this.isNotification.value = router.currentRoute.value.name == 'notification' ? false : this.user.value.notification && this.user.value.notification_count;
        this.setUser(data);
        this.cities.value = res.data.cities;
      })
      .catch((error) => {
        this.errors.value = error;
        this.loading.value = false;
      });
  }

  async getAward() {
    this.errors.value = "";
    this.loading.value = true;
    await axios
      .get("award")
      .then((res) => {
        this.loading.value = false;
        Object.assign(this.award, res.data.data);
      })
      .catch((error) => {
        if (error.response.status !== 404) this.errors.value = error;
        this.loading.value = false;
      });
  }

  async getRegister() {
    this.errors.value = "";
    this.loading.value = true;
    await axios
      .get("register")
      .then((res) => {
        this.loading.value = false;
        this.cities.value = res.data.cities;
        this.privacy.value = res.data.privacy;
        this.ref.value = res.data.ref;
      })
      .catch((error) => {
        this.errors.value = error;
        this.loading.value = false;
      });
  }

  async updateUser(user,toast = true) {
    this.submit.value = true;
    await axios
      .put("user", user)
      .then((res) => {
        this.submit.value = false;
        const data = res.data.data;
        this.setUser(data);
        this.isSidebar.value = data.access;
        if (toast) this.toast.success(res.data.message);
      })
      .catch((error) => {
        window.networkError(error);
        const response = error.response;
        this.submit.value = false;
      });
  }

  async uploadImage(image) {
    window.progressDialog.value = true;
    const file = new FormData();
    file.append('image',image);
    await axios
      .post("user/image",file, { headers: {'Content-Type': 'multipart/form-data'}})
      .then((res) => {
        this.user.value.image = res.data.image
        window.progressDialog.value = false;
        this.toast.success(res.data.message);
      })
      .catch((error) => {
        window.networkError(error);
        window.progressDialog.value = false;
      });
  }

  setUser(user,update = false) {
    if(user.token){
      localStorage.setItem("token", user.token);
      this.token.value = user.token;
      delete user.token;
    }
    localStorage.setItem("user", JSON.stringify({
      name: user.name,
      phone: user.phone,
      referral_code: user.referral_code,
      notification: user.notification,
      access: user.access ? user.access : this.isSidebar.value
    }));
    axios.defaults.headers.common["Authorization"] = "Bearer " + this.token.value;
    this.user.value = user;
    if(!update && !this.isUpdated) this.getUser(true);
  }

  resetForm(){
    this.enterCode.value = false;
    this.timeout.value = null;
  }

  check() {
    return this.token.value;
  }

  async logout() {
    window.progressDialog.value = true;
    await axios
      .post("logout")
      .then((res) => {
        window.progressDialog.value = false;
        this.removeUser();
        this.toast.success(res.data.message);
        router.push({ name: "login" });
      })
      .catch((error) => {
        window.networkError(error);
        window.progressDialog.value = false;
      });
  }

  removeUser(){
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    this.user.value = {};
    this.token.value = null;
    this.isSidebar.value = false;
    this.isUpdated = false;
  }

  stopTimer(){
    if(this.interval)clearInterval(this.interval);
  }

  starTimer(duration) {
    this.stopTimer();
    duration = duration * 60;
    let auth = this;
    auth.timeout.value =
      window.i18n["Request again"] + " (0" + duration / 60 + ":00)";
    duration--;
    let timer = duration,
      minutes,
      seconds;
      this.interval = setInterval(function () {
      minutes = parseInt(timer / 60, 10);
      seconds = parseInt(timer % 60, 10);
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      auth.timeout.value =
        window.i18n["Request again"] + " (" + minutes + ":" + seconds + ")";
      if (timer < 0) {
        auth.timeout.value = null;
        clearInterval(this.interval);
      }
      timer--;
    }, 1000);
  }
}

export default new Auth();
